import ApiConstants from '../constants/ApiConstants';
import Utility from '../utility/Utility';
import http from "../http";
import { getApiRequestOptions, getExportDataFile, getFile } from '../components/import_export/utility/ExportData';
import { supportedFileTypes } from '../components/import_export/EximConstants';
import { AxiosRequestConfig } from 'axios';
import { COLUMN_CODES } from '../constants/Constant';

export interface PayrollAPIConfig {
    // SearchTerm?: string;
    Limit?: number;
    CurrentPage?: number;
    Order?: string;
    Field?:string;
    SearchField?:string;
    SearchString?:boolean;
    processed?:boolean;
    EMPLOYEE_WITH_PROCESSED_STATUS?:boolean;
    PaymentMethod?:string;
}

const defaultConfig: PayrollAPIConfig = {
    Limit: 20,
    CurrentPage: 1,
    Order: 'desc',
    Field: '_id',
    SearchField: '',
    SearchString: false,
    processed:false,
    EMPLOYEE_WITH_PROCESSED_STATUS:false,
    PaymentMethod:''
};

const defaultUserExpenseGroupConfig: PayrollAPIConfig = {
    Limit: 1000,
    CurrentPage: 1,
    Order: 'desc',
    Field: '_id',
    SearchField: '',
    SearchString: false
};
export interface PayScheduleAPIConfig {
    // SearchTerm?: string;
    Limit?: number;
    CurrentPage?: number;
    Order?: string;
    Field?:string;
    SearchField?:string;
    SearchString?:boolean;
}

const defaultPayScheduleConfig: PayScheduleAPIConfig = {
    Limit: 20,
    CurrentPage: 1,
    Order: 'desc',
    Field: '_id',
    SearchField: '',
    SearchString: false
};

class PayrollService {
    static apiConfig: PayrollAPIConfig;
    static apiPayScheduleConfig: PayScheduleAPIConfig;
    static apiUserExpenseGroupConfig: PayrollAPIConfig;

    static conditionalPayrunsConfig;
    static filterArray;

    static conditionalPayscheduleConfig;
    static payscheduleFilterArray;

    static getPayrollByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.PAYROLL.GET_PAYROLL;
        return http
            .get(
                `${url}\
?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.CurrentPage}\
&order=${this.apiConfig.Order}&field=${this.apiConfig.Field}\
${this.apiConfig.SearchField ? '&searchField='+this.apiConfig.SearchField:''}\
${this.apiConfig.SearchString ? '&searchString='+this.apiConfig.SearchString:""}\
${this.apiConfig.processed ? '&EMPLOYEE_WITH_PROCESSED_STATUS='+this.apiConfig.EMPLOYEE_WITH_PROCESSED_STATUS:""}`
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getTenantWorkWeek() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.PAYROLL.GET_WORKWEEK;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                return Promise.reject(err);
            });
    }


    static getPayScheduleList() {
        if (Utility.isEmpty(this.apiPayScheduleConfig)) {
            this.apiPayScheduleConfig = defaultPayScheduleConfig;
        }
        const url = ApiConstants.URL.PAYROLL.GET_PAYSCHEDULELIST;
        return http
            .get(
                `${url}?limit=${this.apiPayScheduleConfig.Limit}&currentPage=${this.apiPayScheduleConfig.CurrentPage}\&order=${this.apiPayScheduleConfig.Order}&field=${this.apiPayScheduleConfig.Field}`
            )
            .catch((err: any) => {
                console.error('Error loading PayScheduleList: ', err);
                return Promise.reject(err);
            });
    }

    static getUsersList() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = `${ApiConstants.URL.PAYROLL.GET_USERS}?ignTeamData=true`;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading users list: ', err);
                return Promise.reject(err);
            });
    }
    static getUsersListWithTeams() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        return http
            .get(ApiConstants.URL.PAYROLL.GET_USERS)
            .catch((err: any) => {
                console.error('Error loading users list: ', err);
                return Promise.reject(err);
            });
    }
    static getUsersExpenseGroup() {
        if (Utility.isEmpty(this.apiUserExpenseGroupConfig)) {
            this.apiUserExpenseGroupConfig = defaultUserExpenseGroupConfig;
        }
        return http
            .get(ApiConstants.URL.EXPENSE.USER_EXPENSE_GROUP)
            .catch((err: any) => {
                console.error('Error loading users list: ', err);
                return Promise.reject(err);
            });
    }
    static getUsersByLocation(location) {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const body = []
        const obj =  {
            colId: COLUMN_CODES.LOCATION_VALUE,
            value: location,
            opr:"eq",
           }
        body.push(obj)
        const url = `${ApiConstants.URL.PAYROLL.FILTER_USER}?ignTeamData=true&includeDraft=false&order=desc&field=_id`;
        return http
            .post(
                `${url}`,
                 {conditions:body}
            )
            .catch((err: any) => {
                console.error('Error loading users list: ', err);
                return Promise.reject(err);
            });
    }
    static getContractorList() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = `${ApiConstants.URL.PAYROLL.GET_USERS}?userType=contractor&ignTeamData=true`;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading users list: ', err);
                return Promise.reject(err);
            });
    }

    static getPayrollOfPayrun(payrunId) {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.PAYROLL.GET_PAYROLL;
        return http
            .get(
                `${url}\/${payrunId}\
?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.CurrentPage}\
&sortOrder=${this.apiConfig.Order}&sortField=${this.apiConfig.Field}&searchField=${this.apiConfig.SearchField}&searchString=${this.apiConfig.SearchString}&paymentMethod=${this.apiConfig.PaymentMethod?this.apiConfig.PaymentMethod:""}`
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }


    static getTenantComponentsData() {

        const url = ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.COMPONENT + `components/tenant?isHidden=true`;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading components list: ', err);
                return Promise.reject(err);
            });
    }
    static getTenantBenefitsData() {

        const url = ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.COMPONENT + `benefits/tenant`;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading components list: ', err);
                return Promise.reject(err);
            });
    }

    static getContractorPayrollByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.PAYROLL.GET_PAYROLL;
        return http
            .get(
                `${url}\?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.CurrentPage}&order=${this.apiConfig.Order}&searchField=${this.apiConfig.SearchField}&searchString=${this.apiConfig.SearchString}`
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getFilteredPayrollByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.PAYROLL.FILTERED_PAYROLL;
        return http
            .post(
                `${url}\
?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.CurrentPage}\
&order=${this.apiConfig.Order}&field=${this.apiConfig.Field}\
${this.apiConfig.SearchField ? '&searchField=' + this.apiConfig.SearchField : ''}\
${this.apiConfig.SearchString ? '&searchString=' + this.apiConfig.SearchString : ""}\
${this.apiConfig.processed ? '&EMPLOYEE_WITH_PROCESSED_STATUS=' + this.apiConfig.EMPLOYEE_WITH_PROCESSED_STATUS : ""}`,
                PayrollService.conditionalPayrunsConfig
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getFilteredPayScheduleList() {
        if (Utility.isEmpty(this.apiPayScheduleConfig)) {
            this.apiPayScheduleConfig = defaultPayScheduleConfig;
        }
        const url = ApiConstants.URL.PAYROLL.FILTERED_PAYSCHEDULE;
        return http
            .post(
                `${url}?limit=${this.apiPayScheduleConfig.Limit}&currentPage=${this.apiPayScheduleConfig.CurrentPage}\&order=${this.apiPayScheduleConfig.Order}&field=${this.apiPayScheduleConfig.Field}`,
                PayrollService.conditionalPayscheduleConfig
            )
            .catch((err: any) => {
                console.error('Error loading PayScheduleList: ', err);
                return Promise.reject(err);
            });
    }

    static downloadPTSFile(payrunId) {
        const config: AxiosRequestConfig = {
            responseType: "blob"
        }
        const URL = ApiConstants.URL.PAYROLL.DOWNLOAD_PTS_FILE(payrunId);
        return http.get(URL, config);
    }

    static getCorrespondingFields(param){
        return http.post(ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.FROM_TO_PAY_PERIOD,param)
    }

    static getTeams() {
        const param = {
            limit:1000,
            currentPage:1
        }
        return http
            .get(ApiConstants.URL.PEOPLE.TEAMS.LIST,{params:param})
            .catch((err: any) => {
                console.error('Error loading users list: ', err);
                return Promise.reject(err);
            });
    }

}

export default PayrollService;
